import { atom } from 'recoil';

export const dataFormCommerce = atom({
  key: 'dataFormCommerce',
  default: undefined,
});
